<div class="ps-small-x">
  <table
    class="monthWrapper fill"
    role="grid"
    [attr.aria-multiselectable]="isDateRange() ? 'true' : 'false'"
    (keydown)="onKeyDown($event)"
  >
    <caption class="title font-body-1 nordic-blue-900-text text-icon-primary bold-type ps-medium font-body-medium-bold">
      {{
        month()?.label
      }}
    </caption>
    <thead>
      <tr>
        @for (dayName of month()?.weekDays?.weekdays; track dayName) {
          <th class="weekDay font-body-2 light-type font-body-small" scope="col" id="{{ dayName }}">
            <abbr title="{{ dayName }}">{{ (month()?.weekDays?.weekdaysShort)[$index] }}</abbr>
          </th>
        }
      </tr>
    </thead>
    <tbody class="calendarBlock">
      @for (week of month()?.weeks ?? []; track week) {
        <tr>
          @for (day of week.days; track day) {
            @if (day?.spacer !== 7 || showEmptyWeeks()) {
              <td
                class="dayWrapper"
                [class.dayCell]="!day.spacer"
                [class.trailingDay]="day.trailing"
                [attr.colspan]="day.spacer"
                [attr.aria-selected]="day.selected"
              >
                <ng-container [ngTemplateOutlet]="dayTemplate()" [ngTemplateOutletContext]="{ day }" />
              </td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
</div>
